import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';

class DocCutomEntitiesValidate extends Component {
    constructor(props){
        super(props);
    }        

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Validate Custom Entity</h3>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V1_EXTRACTION_VALIDATE}
                </code>
                <div className="description">
                    <div className="deprecated">
                        <span className="fa fa-exclamation-triangle">&nbsp;</span>
                        This request is only available to on-prem customers of Finch For Text.
                    </div>
                    <br/>
                    <b>Validate Custom Entity</b><br/>
                    <br/>
                    The validate endpoint allows for a user to validate a collection of entries to insert into the user dictionary without actually updating it. Consider this a “dry run”, if you will. The response will return any and all warnings so that the input data can be corrected.
                    <br/>
                    If the validation returns no warnings, then a follow up insert call should always be successful.
                </div>

                <h4 className="heading-2">Request</h4>

                <h4 className="heading-3" id="enrichv2_request_object">Request object</h4>
                A JSON Custom Entity object is sent as the payload. The following link has a complete documentation for the <Link to="/documentation/doc_customentity#top">Custom Entity Fields</Link>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">entries</td>
                        <td className="meaning">A list of JSON entry objects to ADD or REMOVE tags from the output.
                        </td>
                        <td className="type">entry[]<br/>
                        entries schema documentation is found <Link to="/documentation/doc_customentity#custom_entity_entry_object">here</Link><br/></td>
                        <td className="type">
                            Required
                        </td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                    POST {urlHandler.API_ENDPOINT_V1_EXTRACTION_VALIDATE}<br/>
                    Accept: application/JSON<br/>
                    Authorization: Bearer [YOUR-API-KEY]<br/>
                    Content-Type: application/json<br/>
                    <br/>
                    {JSON.stringify(examples.EXAMPLE_REQUEST_VALIDATE, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-2">Response</h4>

                <h4 className="heading-3">Response object</h4>
                <div className="description">
                    The response object contains a information on the status of the Custom Entity change as well as accessory information about the change.
                </div>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Values </th>
                        <th>Default </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">A specific code indicating a success or failure.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">message</td>
                        <td className="meaning">A simple message about what was completed.</td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute"><i>details</i></td>
                        <td className="meaning">A list of details regarding any issues with the request. May be empty if the request is a success.</td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3">Example</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_NO_DETAILS, null, 3)}
                    </pre>
                </div>

                <h4 className="heading-3">Example With Details/Warnings</h4>
                <div className="example-content host">
                    <pre>
                        {JSON.stringify(examples.EXAMPLE_RESPONSE_EXTRACTION_VALIDATE_DETAILS, null, 3)}
                    </pre>
                </div>
            </div>
        );
    }
}

export default DocCutomEntitiesValidate;